import { FooterAnchor } from './styles'
import { HTMLAttributes, ReactElement, ReactNode } from 'react'

type FooterLinkProps = {
  href: string
  target?: '_blank'
  rel?: 'noopener noreferrer nofollow'
  children: ReactNode
} & HTMLAttributes<Element>

export type FooterTextLink = Omit<FooterLinkProps, 'as' | 'children'> & {
  label: string
}

export const FooterLink = ({
  href,
  target,
  rel,
  children,
  ...rest
}: FooterLinkProps): ReactElement => {
  return (
    <FooterAnchor href={href} target={target} rel={rel} {...rest}>
      {children}
    </FooterAnchor>
  )
}
